export class UpdateGcpRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateGcpRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
